import React from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import {
  TitleWrap,
  SecSubTitle,
  SecTitle,
  List,
  Button,
} from "../../components";

const AboutSix = ({ className }) => {
  const TABDATA = [
    {
      id: "tab1",
      title: "Functional SAP Modules",
      subtitle: "Master Core Business Processes",
      icon: "images/icon/sr-icon-3-1.png",
      image: "images/about/ab-6-1.jpg",
      text: "Develop a deep understanding of core SAP modules like FI, CO, MM, SD, and HCM. Learn how financial accounting, material management, and human capital operations work seamlessly in enterprise environments.",
      feature: [
        "Comprehensive Functional Training",
        "Business Process Integration",
        "Hands-On ERP Scenarios",
        "Expert-Led Live Sessions",
      ],
      btntext: "Explore Functional Modules",
      path: "/training/functional",
    },
    {
      id: "tab2",
      title: "Technical SAP Modules",
      subtitle: "Build the Foundation of Enterprise Systems",
      icon: "images/icon/sr-icon-3-2.png",
      image: "images/about/ab-6-2.jpg",
      text: "Learn the technical backbone of SAP with modules such as ABAP, BASIS, and SAP Security. Get hands-on experience in coding, system monitoring, and performance optimization for large-scale business systems.",
      feature: [
        "ABAP Development & Customization",
        "System Administration (BASIS)",
        "Performance Tuning & Debugging",
        "Security Configuration & Controls",
      ],
      btntext: "Learn Technical Modules",
      path: "/training/technical",
    },
    {
      id: "tab3",
      title: "SAP Analytics & Cloud",
      subtitle: "Turn Data Into Business Intelligence",
      icon: "images/icon/sr-icon-3-3.png",
      image: "images/about/ab-6-3.jpg",
      text: "Empower decision-making through SAP Analytics Cloud and BusinessObjects. Build dynamic dashboards, automate reports, and gain insights that drive enterprise performance and efficiency.",
      feature: [
        "SAP Analytics Cloud (SAC)",
        "BI / BO Dashboard Creation",
        "Data Visualization & KPIs",
        "Cloud System Integration",
      ],
      btntext: "Explore Analytics Training",
      path: "/training/analytics",
    },
    {
      id: "tab4",
      title: "Corporate & Certification Programs",
      subtitle: "Upskill Teams and Professionals",
      icon: "images/icon/sr-icon-3-4.png",
      image: "images/about/ab-6-4.jpg",
      text: "Tailored SAP training programs for corporate teams and individuals preparing for certification. Includes guided mentorship, mock assessments, and post-training placement support.",
      feature: [
        "Corporate Custom Modules",
        "SAP Certification Prep",
        "Mentor-Guided Learning Path",
        "Career & Placement Support",
      ],
      btntext: "Start Corporate Training",
      path: "/training/corporate",
    },
    {
      id: "tab5",
      title: "SAP S/4HANA & Cloud Integration",
      subtitle: "Stay Ahead With Next-Gen ERP",
      icon: "images/icon/sr-icon-3-5.png",
      image: "images/about/ab-6-5.jpg",
      text: "Learn how to migrate to SAP S/4HANA and integrate your systems with cloud platforms like AWS and Azure. Ideal for consultants and enterprises modernizing their ERP systems.",
      feature: [
        "S/4HANA Migration Tools",
        "Integration With Cloud Platforms",
        "System Conversion Best Practices",
        "Hands-On Cloud Lab Access",
      ],
      btntext: "Learn S/4HANA Integration",
      path: "/training/s4hana",
    },
  ];

  return (
    <div className={`position-relative ${className || ""}`}>
      <div className="service-shape1"></div>
      <div className="container">
        <TitleWrap className="text-center">
          <SecSubTitle>Types Of Our Services</SecSubTitle>
          <SecTitle className="text-capitalize h1">
            Our Available Services
          </SecTitle>
        </TitleWrap>
        <Tab.Container id="serviceTab" defaultActiveKey={TABDATA[0].id}>
          <Nav className="service-tab-menu">
            {TABDATA.map((item) => (
              <Nav.Link key={item.id} eventKey={item.id}>
                <span className="btn-img">
                  <img src={item.icon} alt="tabicon" />
                </span>
                <span className="btn-title h6">{item.title}</span>
                <span className="btn-text">{item.subtitle}</span>
              </Nav.Link>
            ))}
          </Nav>
          <Tab.Content>
            {TABDATA.map((item) => (
              <Tab.Pane key={item.id} eventKey={item.id}>
                <div className="row gx-60 gy-30">
                  <div className="col-lg-6">
                    <img
                      src={item.image}
                      alt="tabthumb"
                      style={{ borderRadius: "7px", width: "100%" }}
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="about-box1">
                      <h2 className="about-title h3">{item.title}</h2>
                      <span className="about-subtitle">{item.subtitle}</span>
                      <p className="about-text">{item.text}</p>
                      <List className="list-style2">
                        {item.feature.map((list, index) => (
                          <List.Item key={index}>
                            <i className="fas fa-check-circle" />
                            {list}
                          </List.Item>
                        ))}
                      </List>
                      <Button path={item.path}>
                        {item.btntext}
                        <i className="far fa-arrow-right" />
                      </Button>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default AboutSix;
